import React from 'react';
import { cn } from '../../utils/cn';

export interface SwitchProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

export const Switch: React.FC<SwitchProps> = ({
  checked = false,
  onCheckedChange,
  size = 'md',
  label,
  className,
  disabled,
  ...props
}) => (
  <div className={cn('app-switch', className)}>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onCheckedChange?.(!checked)}
      className={cn(
        'app-switch__track',
        `app-switch__track--${size}`,
        checked && 'app-switch__track--checked',
        disabled && 'app-switch__track--disabled'
      )}
      {...props}
    >
      <span
        className={cn('app-switch__thumb', `app-switch__thumb--${size}`)}
        aria-hidden
      />
    </button>
    {label ? <span className="app-switch__label">{label}</span> : null}
  </div>
);
